var chunkMapping = {
	"187": [
		735,
		5195,
		5993,
		7274
	],
	"226": [
		4226
	],
	"298": [
		5437
	],
	"504": [
		2504
	],
	"527": [
		2527
	],
	"542": [
		5542
	]
};
var idToExternalAndNameMapping = {
	"735": [
		"default",
		"./handlers",
		5316
	],
	"2504": [
		"default",
		"./routes",
		3234
	],
	"2527": [
		"default",
		"./routes",
		6192
	],
	"4226": [
		"default",
		"./routes",
		6553
	],
	"5195": [
		"default",
		"./handlers",
		6553
	],
	"5437": [
		"default",
		"./atoms",
		6192
	],
	"5542": [
		"default",
		"./routes",
		5316
	],
	"5993": [
		"default",
		"./handlers",
		3234
	],
	"7274": [
		"default",
		"./handlers",
		6192
	]
};
var idToRemoteMap = {
	"735": [
		{
			"externalType": "script",
			"name": "companyApp"
		}
	],
	"2504": [
		{
			"externalType": "script",
			"name": "contribuitionApp"
		}
	],
	"2527": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"4226": [
		{
			"externalType": "script",
			"name": "personApp"
		}
	],
	"5195": [
		{
			"externalType": "script",
			"name": "personApp"
		}
	],
	"5437": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	],
	"5542": [
		{
			"externalType": "script",
			"name": "companyApp"
		}
	],
	"5993": [
		{
			"externalType": "script",
			"name": "contribuitionApp"
		}
	],
	"7274": [
		{
			"externalType": "script",
			"name": "mutationsApp"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"735": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 5316,
		"remoteName": "companyApp"
	},
	"2504": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 3234,
		"remoteName": "contribuitionApp"
	},
	"2527": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 6192,
		"remoteName": "mutationsApp"
	},
	"4226": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 6553,
		"remoteName": "personApp"
	},
	"5195": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 6553,
		"remoteName": "personApp"
	},
	"5437": {
		"shareScope": "default",
		"name": "./atoms",
		"externalModuleId": 6192,
		"remoteName": "mutationsApp"
	},
	"5542": {
		"shareScope": "default",
		"name": "./routes",
		"externalModuleId": 5316,
		"remoteName": "companyApp"
	},
	"5993": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 3234,
		"remoteName": "contribuitionApp"
	},
	"7274": {
		"shareScope": "default",
		"name": "./handlers",
		"externalModuleId": 6192,
		"remoteName": "mutationsApp"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}